export default "__VITE_ASSET__Dv8jAQ5z__"